import { DEFAULT_VARIANT, Icon } from "../Icon.js";
import { jsx } from "react/jsx-runtime";
import { useTranslation } from "react-i18next";

//#region src/components/icon/variants/IconShoppingBag.tsx
const OutlinedFilledShoppingBag = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M229-55q-39.05 0-66.52-27.47Q135-109.95 135-149v-490q0-39.46 27.48-67.23Q189.95-734 229-734h84v-10q2-68 50.5-115T480-906q68 0 116.5 47T647-744v10h84q39.46 0 67.23 27.77Q826-678.46 826-639v490q0 39.05-27.77 66.53Q770.46-55 731-55H229Zm179-679h144v-10q-2-28-22.5-47.5T480-811q-29 0-49.5 19.5T408-744v10Zm192 215q20 0 33.5-13.5T647-566v-73h-94v73q0 20 13.5 33.5T600-519Zm-240 0q20 0 33.5-13.5T407-566v-73h-94v73q0 20 13.5 33.5T360-519Z" })
});
const OutlinedShoppingBag = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M229-55q-39.05 0-66.52-27.47Q135-109.95 135-149v-490q0-39.46 27.48-67.23Q189.95-734 229-734h84v-10q2-68 50.32-115 48.33-47 116.5-47 68.18 0 116.68 47T647-744v10h84q39.46 0 67.23 27.77Q826-678.46 826-639v490q0 39.05-27.77 66.53Q770.46-55 731-55H229Zm0-94h502v-490h-84v73q0 19.75-13.68 33.37Q619.65-519 599.82-519q-19.82 0-33.32-13.63Q553-546.25 553-566v-73H407v73q0 19.75-13.68 33.37Q379.65-519 359.82-519q-19.82 0-33.32-13.63Q313-546.25 313-566v-73h-84v490Zm179-585h144v-10q-2-28-22.6-47.5-20.59-19.5-49.5-19.5-28.9 0-49.4 19.5T408-744v10ZM229-149v-490 490Z" })
});
const RoundedFilledShoppingBag = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M229-55q-39.05 0-66.52-27.47Q135-109.95 135-149v-490q0-39.46 27.48-67.23Q189.95-734 229-734h84v-10q2-68 50.5-115T480-906q68 0 116.5 47T647-744v10h84q39.46 0 67.23 27.77Q826-678.46 826-639v490q0 39.05-27.77 66.53Q770.46-55 731-55H229Zm179-679h144v-10q-2-28-22.5-47.5T480-811q-29 0-49.5 19.5T408-744v10Zm192 215q20 0 33.5-13.5T647-566v-73h-94v73q0 20 13.5 33.5T600-519Zm-240 0q20 0 33.5-13.5T407-566v-73h-94v73q0 20 13.5 33.5T360-519Z" })
});
const RoundedShoppingBag = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M229-55q-39.05 0-66.52-27.47Q135-109.95 135-149v-490q0-39.46 27.48-67.23Q189.95-734 229-734h84v-10q2-68 50.32-115 48.33-47 116.5-47 68.18 0 116.68 47T647-744v10h84q39.46 0 67.23 27.77Q826-678.46 826-639v490q0 39.05-27.77 66.53Q770.46-55 731-55H229Zm0-94h502v-490h-84v73q0 19.75-13.68 33.37Q619.65-519 599.82-519q-19.82 0-33.32-13.63Q553-546.25 553-566v-73H407v73q0 19.75-13.68 33.37Q379.65-519 359.82-519q-19.82 0-33.32-13.63Q313-546.25 313-566v-73h-84v490Zm179-585h144v-10q-2-28-22.6-47.5-20.59-19.5-49.5-19.5-28.9 0-49.4 19.5T408-744v10ZM229-149v-490 490Z" })
});
const SharpFilledShoppingBag = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M135-55v-679h178v-10q2-68 50.32-115 48.33-47 116.5-47 68.18 0 116.68 47T647-744v10h179v679H135Zm273-679h144v-10q-2-28-22.6-47.5-20.59-19.5-49.5-19.5-28.9 0-49.4 19.5T408-744v10Zm-95 215h94v-120h-94v120Zm240 0h94v-120h-94v120Z" })
});
const SharpShoppingBag = (props) => /* @__PURE__ */ jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 -960 960 960",
	...props,
	children: /* @__PURE__ */ jsx("path", { d: "M135-55v-679h178v-10q2-68 50.32-115 48.33-47 116.5-47 68.18 0 116.68 47T647-744v10h179v679H135Zm94-94h502v-490h-84v120h-94v-120H407v120h-94v-120h-84v490Zm179-585h144v-10q-2-28-22.6-47.5-20.59-19.5-49.5-19.5-28.9 0-49.4 19.5T408-744v10ZM229-149v-490 490Z" })
});
const componentMap = {
	outlined: OutlinedShoppingBag,
	"outlined-fill": OutlinedFilledShoppingBag,
	rounded: RoundedShoppingBag,
	"rounded-fill": RoundedFilledShoppingBag,
	sharp: SharpShoppingBag,
	"sharp-fill": SharpFilledShoppingBag
};
const IconShoppingBag = ({ color, filled, height, variant = "rounded", style = {}, width, "data-testid": testId }) => {
	const { t } = useTranslation("pds");
	return /* @__PURE__ */ jsx(Icon, {
		SvgIcon: componentMap[`${variant}${filled ? "-fill" : ""}`] ?? componentMap[DEFAULT_VARIANT],
		alt: t(""),
		"data-testid": testId,
		color,
		style,
		height,
		width
	});
};

//#endregion
export { IconShoppingBag };